/** The site's ease-out (usd.ai's `--ease-cb-out`). */
export const EASE = [0.22, 1, 0.36, 1] as const;

/** The buttons here set their labels in the regular weight, as the mock does. */
export const REGULAR = "font-normal!";
